<a (click)="navSupport()" (keyup.enter)="navSupport">Contact Us</a>
<p>{{email}}</p>